import { DATE_TIME_FORMAT } from '../constants';
import moment from 'moment';
import { getCarrier } from './getCarrier';

export const exportToCsv = (filename, csvFile) => {
  const blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, filename);
  } else {
    let link = document.createElement('a');
    if ('download' in link) {
      // feature detection
      // Browsers that support HTML5 download attribute
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  }
};

export const getUniqKeys = (items) => {
  let keys = [];

  for (let item of items) {
    for (let key of Object.keys(item)) {
      if (!keys.includes(key)) {
        keys.push(key);
      }
    }
  }

  return keys;
};
/**
 * Function designed to change order of keys in arrays.
 *
 * @param {Array} keys csv keys array
 * @param {Array} nearFields array of arrays, where inner arrays is a sequense of fields that should be placed in strict order
 *
 * @returns {Array} new keys array
 */
export const makeFieldsNear = (keys, nearFields) => {
  nearFields.forEach((items) => {
    let firstItem;

    for (let item of items) {
      const index = keys.findIndex((key) => key === item);
      if (index !== -1) {
        firstItem = item;
        break;
      }
    }

    const itemsIncluded = items.filter((item) => keys.includes(item));
    let newKeys = keys.filter(
      (key) => !itemsIncluded.includes(key) || key === firstItem,
    );

    const firstItemIndex = newKeys.findIndex((key) => key === firstItem);
    if (firstItemIndex !== -1) {
      newKeys.splice(firstItemIndex, 1, ...itemsIncluded);
    }

    keys = newKeys;
  });

  return keys;
};

export const tranformSubCellValue = (item, key) => {
  const value = item[key];

  if (key === 'service_codes' && typeof value === 'object') {
    return value
      .map((code) => value[code] && value[code].description)
      .filter(Boolean)
      .join(' | ');
  }

  if (key === 'carrier') {
    return getCarrier(item);
  }

  if (key === 'user_id') {
    return item.user_profile;
  }

  if (key === 'sub_id') {
    return item.id;
  }

  if (key === 'plan_id') {
    return item.plan ? item.plan.id : '';
  }

  if (key === 'plan_name') {
    return item.plan ? item.plan.name : '';
  }
  if (key === 'status') {
    return item.att_status || item.tracfone_status || item.sprint_status;
  }

  if (typeof value === 'object' && value !== null) {
    return value.id ? value.id : 'object';
  }

  if (value === undefined) {
    return '';
  }

  if (key.toLowerCase() === 'model') {
    return `"${value}"`;
  }

  return value;
};

export const serializeObjectIntoCsv = (obj) => {
  if (!obj) {
    return '';
  }

  return `"${JSON.stringify(obj).replace(/"/gi, "\\'")}"`;
};

export const tranformLineItemCellValue = (item, key) => {
  const value = item[key];

  if (key === 'from_date' || key === 'to_date') {
    return moment(value).format(DATE_TIME_FORMAT);
  }

  if (key === 'mdn') {
    return item.subscription_mdn;
  }

  if (key === 'carrier') {
    if (item.sprint_subscription) {
      return 'Sprint';
    } else if (item.att_subscription) {
      return 'AT&T';
    } else if (item.tracfone_subscription) {
      return 'Tracfone';
    }
    return '';
  }

  if (key === 'sprint_plan' || key === 'att_plan' || key === 'tracfone_plan') {
    return item[key] ? item[key].name : '';
  }

  if (typeof value === 'object' && value !== null) {
    return value.id ? value.id : serializeObjectIntoCsv(value);
  }

  if (value === undefined) {
    return '';
  }

  return value;
};
